import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ClassExamsLazy = React.lazy(
	() => import(/* webpackChunkName : 'ClassExams' */ './components')
);

export default (store) => {
	return {
		path: 'exams',
		element: <AsyncLoading component={<ClassExamsLazy />} />,
	};
};
